import { type ChangeEvent, createContext, type FC, type ReactElement, useState } from 'react';
import { usePagination } from '../content/hooks';
import type { BannerModel } from '../models';

interface IBannersContext {
  bannersUpdate: boolean;
  toggleBannersUpdate: () => void;
  banners: BannerModel[];
  setBanners: (val: BannerModel[]) => void;
  page: number;
  setPage: (val: number) => void;
  limit: number;
  setLimit: (val: number) => void;
  count: number;
  setCount: (val: number) => void;
  handlePageChange: (_event: any, newPage: number) => void;
  handleLimitChange: (event: ChangeEvent<HTMLInputElement>) => void;
  loading: boolean;
  setLoading: (val: boolean) => void;
}

export const BannersContext = createContext<IBannersContext>({} as IBannersContext);

export const BannersProvider: FC<{ children: ReactElement }> = ({ children }) => {
  const [bannersUpdate, setBannersUpdate] = useState(false);
  const toggleBannersUpdate = (): void => setBannersUpdate(!bannersUpdate);

  const { page, setPage, limit, setLimit, count, setCount, handlePageChange, handleLimitChange } =
    usePagination<'createdAt'>(toggleBannersUpdate, 'createdAt', 'desc');

  const [banners, setBanners] = useState<BannerModel[]>([]);
  const [loading, setLoading] = useState(false);

  return (
    <BannersContext.Provider
      value={{
        bannersUpdate,
        toggleBannersUpdate,
        banners,
        setBanners,
        page,
        setPage,
        limit,
        setLimit,
        count,
        setCount,
        handlePageChange,
        handleLimitChange,
        loading,
        setLoading
      }}
    >
      {children}
    </BannersContext.Provider>
  );
};
